import { render } from "./BlankTitle.vue?vue&type=template&id=403ea213"
import script from "./BlankTitle.vue?vue&type=script&lang=js"
export * from "./BlankTitle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__